export function TermsAndConditions() {
  return (
    <div className="text-sm text-gray-600 mb-6">
      <h4 className="font-semibold mb-2">Terms and Conditions</h4>
      <ul className="list-disc pl-5 space-y-1">
        <li>Booking confirmation is subject to contact verification</li>
        <li>Final fare may vary based on actual route and waiting time</li>
      </ul>
    </div>
  );
}